import React from 'react'
import { useSelector } from 'react-redux'
import { DialogBox } from 'components/Zui'
import { useIntl } from 'hooks'
import { validationSchema } from 'schema/editUser'
import { getCountryList, getProfileSalutation } from 'utils/helpers'
import { mappedLanguages } from 'features/auth/appSlice'
import { FormContainer, Input, Select } from 'components/Form'
import Modal from 'components/Modals'
import { Badge } from 'components/Form/Static'

const EditUser = ({ onSubmit, onClose, data }) => {
    const { t } = useIntl()
    const lang = useSelector(mappedLanguages)

    return (
        <Modal>
            <FormContainer
                initialValues={{
                    email: data.emailId,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    middleName: data.middleName || '',
                    title: [data.title],
                    status: data.onboardingStatus,
                    language: [data.language],
                    country: data.country ? [data.country] : [],
                }}
                onSubmit={values => {
                    onSubmit(values)
                }}
                validationSchema={validationSchema(t)}
            >
                {formik => {
                    return (
                        <DialogBox
                            closable
                            headerText={t('user.edit.title')}
                            acceptLabel={t('save')}
                            cancelLabel={t('cancel')}
                            onClose={onClose}
                            onCancel={onClose}
                            onAccept={formik.handleSubmit}
                        >
                            <div className="dialog-content-wrap">
                                <Select
                                    name="title"
                                    horizontal
                                    options={getProfileSalutation()}
                                    label={t('label.title')}
                                />

                                <Input
                                    name="lastName"
                                    type="text"
                                    label={t('label.lastname')}
                                    horizontal
                                />
                                <Input
                                    name="firstName"
                                    type="text"
                                    label={t('label.firstname')}
                                    horizontal
                                />
                                <Input
                                    name="middleName"
                                    type="text"
                                    label={t('label.middlename')}
                                    horizontal
                                />
                                <Input
                                    name="email"
                                    horizontal
                                    static
                                    label={t('label.EMAIL.ADDR')}
                                />

                                <Input
                                    name="status"
                                    static
                                    horizontal
                                    badgeState="ready"
                                    component={Badge}
                                    label={t('label.STATUS')}
                                />

                                <Select
                                    name="language"
                                    placeholder={data.language}
                                    horizontal
                                    options={lang}
                                    label={t('label.language')}
                                />
                                <Select
                                    name="country"
                                    horizontal
                                    options={getCountryList()}
                                    label={t('label.country')}
                                />
                            </div>
                        </DialogBox>
                    )
                }}
            </FormContainer>
        </Modal>
    )
}

export default EditUser
